export const evaluate = <T extends string>(
  statements: Record<T, boolean | string | number | undefined | null>,
): T | undefined =>
  Object.keys(statements).find((key) => statements[key as T]) as T | undefined;
